(() => {
  'use strict';
  const configNode = document.getElementById('ap-campaign-cart-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const root = config.root.replace(/\/?$/, '/');
  let queue = Promise.resolve();
  let lastCart;
  const isGift = item => String(item.product_id) === String(config.giftProduct);
  const purchasedCount = cart => cart.items.reduce((total, item) => total + (!isGift(item) && item.original_price > 0 ? item.quantity : 0), 0);
  function showError(message = '') {
    document.querySelectorAll('[data-bf-cart-error]').forEach(node => {
      node.textContent = message;
      node.hidden = !message;
    });
  }
  async function request(path, data) {
    const response = await fetch(root + path, {
      method: data ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: data ? JSON.stringify(data) : undefined
    });
    const body = await response.json();
    if (!response.ok) throw new Error(body.description || body.message || 'Cart unavailable');
    return body;
  }
  function render(cart = lastCart) {
    if (!cart) return;
    lastCart = cart;
    const count = purchasedCount(cart);
    const complete = count >= config.shippingThreshold;
    document.querySelectorAll('.amcart-shipping').forEach(node => {
      node.classList.toggle('is-complete', complete);
      node.querySelector('[data-bf-shipping-fill]').style.width = Math.min(100, count / config.shippingThreshold * 100) + '%';
      node.querySelector('[data-bf-shipping-message]').textContent = complete ? config.shippingFree : (count === 0 ? config.shippingEmpty : config.shippingPending);
    });
  }
  async function normalize() {
    let cart = await request('cart.js');
    const count = purchasedCount(cart);
    const gifts = cart.items.filter(isGift);
    const updates = {};
    gifts.forEach((item, index) => {
      const desired = config.giftEnabled && count > 0 && index === 0 ? 1 : 0;
      if (item.quantity !== desired) updates[item.key] = desired;
    });
    if (Object.keys(updates).length) cart = await request('cart/update.js', {updates});
    if (config.giftEnabled && count > 0 && gifts.length === 0) {
      await request('cart/add.js', {items: [{id: config.giftVariant, quantity: 1, properties: {_amelia_gift: 'black-friday', _gift_source: 'classic-tennis-bracelet'}}]});
      cart = await request('cart.js');
    }
    const gift = cart.items.find(isGift);
    if (config.giftEnabled && count > 0 && (!gift || gift.quantity !== 1 || gift.final_line_price !== 0)) throw new Error('Gift unavailable');
    showError();
    render(cart);
    return cart;
  }
  function synchronize() {
    const task = queue.catch(() => {}).then(normalize);
    queue = task;
    return task.catch(error => {
      showError(config.error);
      throw error;
    });
  }
  function refresh(silent = false) {
    const items = document.querySelector('cart-items');
    if (items) items.getCart({silent});
  }
  customElements.whenDefined('cart-items').then(() => {
    const prototype = customElements.get('cart-items').prototype;
    if (prototype.ameliaBlackFriday) return;
    prototype.getCart = function ({silent = false} = {}) {
      return synchronize().then(async () => {
        const response = await fetch(root + 'cart?section_id=api-cart-items', {credentials: 'same-origin', cache: 'no-store'});
        if (!response.ok) throw new Error('Cart unavailable');
        const wrapper = document.createElement('div');
        wrapper.innerHTML = await response.text();
        const content = wrapper.querySelector('[data-api-content]');
        if (!content) throw new Error('Cart markup unavailable');
        // Native build emits product:added even for background refreshes.
        const suppressAdded = event => event.stopImmediatePropagation();
        if (silent) document.addEventListener('theme:product:added', suppressAdded, true);
        try { this.build(content); }
        finally { if (silent) document.removeEventListener('theme:product:added', suppressAdded, true); }
      }).catch(() => { showError(config.error); this.enableCartButtons(); });
    };
    prototype.ameliaBlackFriday = true;
    document.addEventListener('theme:cart:change', () => render());
    document.addEventListener('theme:cart-drawer:open', () => render());
    window.addEventListener('pageshow', event => { if (event.persisted) refresh(true); });
    refresh(true);
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('[data-cart-form]')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const terms = form.querySelector('[data-cart-acceptance-checkbox]');
    if (terms && !terms.checked) { terms.required = true; terms.reportValidity(); return; }
    const button = event.submitter || form.querySelector('[name="checkout"]');
    if (button) button.disabled = true;
    synchronize().then(cart => {
      if (purchasedCount(cart)) window.location.assign(root + 'checkout');
      else refresh();
    }).catch(() => {}).finally(() => { if (button) button.disabled = false; });
  }, true);
})();
